import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { getMyself } from '@adornis/users/db/api/currentUserInfo.operations.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';
import { getCvReviewUsageForUser } from '../server/reviewCvFile.js';

@Entity()
export class CvReviewUsageInfo extends AdornisEntity {
  static override _class = 'CvReviewUsageInfo';

  constructor(doc: PartialEntityData<CvReviewUsageInfo>) {
    super(doc);
  }

  @Field(() => Int)
  used!: number;

  @Field(() => Int)
  remaining!: number;

  @Field(() => Int)
  limit!: number;
}

export const cvReviewUsageQuery = registerQuery({
  type: () => CvReviewUsageInfo,
  operationName: 'cvReviewUsage',
  resolve: () => async (_gqlFields: BaseQLSelectionSet<CvReviewUsageInfo>) => {
    const user = await getMyself()({ _id: 1 });
    if (!user) throw new NotLoggedInError();
    const usage = await getCvReviewUsageForUser(user._id);
    return new CvReviewUsageInfo(usage);
  },
});
